// extracted by mini-css-extract-plugin
export default {"top":"headerBookDetails_top__SCJC5","thumbnail":"headerBookDetails_thumbnail__zhHdd","info":"headerBookDetails_info__GiHgm","spacer":"headerBookDetails_spacer__g-d1x"};